import { Locale } from 'dibs-intl/exports/constants';
import { handleLocaleUrl } from 'dibs-intl/exports/handleLocaleUrl';
import { useIntl } from './IntlContext';

export function useLocaleUrl(url: string, locale?: Locale): ReturnType<typeof handleLocaleUrl> {
    const intl = useIntl();
    locale = locale || intl.locale;
    return handleLocaleUrl(url, locale);
}
